import NavBarTopType from "../types/NavBarTopType";
import NavBarType from "../types/NavBarTopType";

const NavBarTop = ({ textToBeDispalyed, imagePath }: NavBarTopType) => {
  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary sticky-top NavBarTop">
      <div className="container-fluid">
        <a className="navbar-brand" href="#">
          <img src={imagePath} height={50} width={50}></img>
          {textToBeDispalyed}
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link active" aria-current="page" href="#">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#about">
                About Me!
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#skill">
                Skills
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#experience">
                Experience
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#education">
                Education
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBarTop;
